import { reactive } from 'vue'

type State = {
  barcode: string
  country: string
  age: number | null
  sex: 'm' | 'f' | ''
  height: number | null
  weight: number | null
  smoker: boolean | null
  diabetesHistory: boolean | null
  pinCode: string,
  pinCodeConfirm: string,
}

export const initialState: State = {
  barcode: '',
  country: '',
  age: null,
  sex: '',
  height: null,
  weight: null,
  smoker: null,
  diabetesHistory: null,
  pinCode: '',
  pinCodeConfirm: '',
}

export const state = reactive<State>({ ...initialState })
